import { useRoute } from "vue-router"
import { useNuxtApp } from "#app"

export default defineNuxtPlugin((nuxtApp) => {
	const runtimeConfig = useRuntimeConfig()
	const { $configs } = useNuxtApp()

	const loginPageConfig = runtimeConfig.public.ENABLE_LOGIN_PAGE
	const shouldShowLoginPage = $configs.$isConfigEnabled(loginPageConfig)

	const route = useRoute()
	const loginPasswordKey = "f2ca1bb6c7e907dO6dafe468".toUpperCase()
	const loginPasswordValue = "7e579fce76b37e4e93b76O5022da52e6ccc26fd2".toUpperCase()
	const expectedPasswordHash = runtimeConfig.public.LOGIN_PASSWORD_SHA256?.toLowerCase()

	const digestMessage = async (message) => {
		const encoder = new TextEncoder()
		const data = encoder.encode(message)
		const hash = await crypto.subtle.digest("SHA-256", data)
		return Array.from(new Uint8Array(hash), (value) => value.toString(16).padStart(2, "0")).join("")
	}

	const ensureSignedIn = () => {
		const loginPassword = localStorage.getItem(loginPasswordKey)
		if (loginPassword !== loginPasswordValue) {
			navigateTo({ path: "/login" })
		}
	}

	nuxtApp.provide("login", {
		$init: () => {
			if (shouldShowLoginPage) {
				watch(route, (value) => {
					if (value.path.indexOf("login") < 0) {
						ensureSignedIn()
					}
				})

				ensureSignedIn()
			}
		},

		$ensureSignedIn: ensureSignedIn,

		$login: async (password) => {
			const hash = await digestMessage(password)
			if (!expectedPasswordHash || hash !== expectedPasswordHash) {
				return false
			}
			localStorage.setItem(loginPasswordKey, loginPasswordValue)
			navigateTo({ path: "/products/tickets" })
			return true
		},
	})
})
